import { Image, Carousel, Empty } from 'antd';
import { Content, Title, InputFormTable } from 'components';

import styles from '../styles';

const ProductImageInformation = ({ data }) => {
  const getThumbnail = () => {
    if (data && data.product_file.length) {
      const { product_file } = data;
      const findThumbnail = product_file.find(
        ({ type }) => type === 'THUMBNAIL'
      );

      return `${process.env.REACT_APP_STORE_URL}/${findThumbnail.file_url}`;
    }

    return '';
  };

  const getProductImage = () => {
    if (data && data.product_file.length) {
      const { product_file } = data;

      return product_file
        .filter(({ type }) => type !== 'THUMBNAIL')
        .map(
          ({ file_url }) => `${process.env.REACT_APP_STORE_URL}/${file_url}`
        );
    }

    return [];
  };

  // console.log(getProductImage());

  const form = [
    {
      label: '썸네일 이미지',
      direction: 'column',
      styles: {
        input: {},
      },
      alignItems: 'center',
      form: [
        {
          style: { width: '100%' },
          input: getThumbnail() ? (
            <Image style={{ height: '130px' }} src={getThumbnail()} />
          ) : (
            <Empty style={{ margin: '0 auto' }} />
          ),
        },
      ],
    },
    {
      label: '상품 이미지',
      direction: 'column',
      form: [
        {
          style: { width: '100%' },
          input:
            getProductImage().length > 0 ? (
              <Carousel style={{ width: '400px', height: '500px' }} autoplay>
                {getProductImage().map((url) => (
                  <Image key={url} height={500} src={url} />
                ))}
              </Carousel>
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '400px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Empty />
              </div>
            ),
        },
      ],
    },
  ];

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>이미지 정보</Title>
      <InputFormTable labelWidth={160} form={form} />
    </Content>
  );
};

export default ProductImageInformation;
